import { createFileRoute } from '@tanstack/react-router';

import { NIS2GapAnalysisPage } from '@/features/nis2/components/NIS2GapAnalysisPage';
import i18n from '@/lib/i18n';

export const Route = createFileRoute('/_authenticated/nis2/gap-analysis')({
  beforeLoad: () => ({
    getTitle: () => i18n.t('routeTitles.nis2GapAnalysis'),
  }),
  component: NIS2GapAnalysisPage,
});
